import { AccountBalancesCurrencyTile } from './AccountBalancesCurrencyTile';

export default AccountBalancesCurrencyTile;